<!--
 * @Author: CYX
 * @Date: 2020-05-12 11:45:13
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-09 10:10:21
--> 
/** 404 **/
<template>
    <div class="notfound">
        <h1>404</h1>
        <el-button plain @click="back">{{$t('message.ConsultationOrderLang.fanhui')}}</el-button>
    </div>
</template>

<script>
export default {
  name: 'Notfound',
  components: {

  },
  data() { 
    return {
      
    }
  },
  methods: {
      back(){
          this.$router.go(-1);
      }
  }
 }
</script>

<style lang="less" scoped>
.notfound{
    background:linear-gradient(270deg,rgba(101,183,255,1) 0%,rgba(48,110,203,1) 100%);
    padding-top: 100px;
    height: 100vh;
    text-align: center;
    h1{
        font-size: 100px;
        margin-bottom: 30px;
    }
}
</style> 




// WEBPACK FOOTER //
// src/base/Notfound/index.vue